<template>
  <div class="distribution">
    <div class="header">
      <div class="header-left">
        <div class="header-title">
          <div class="page-num">{{ pageNo + 1 + "/" + total }}</div>
          <h2>配货单</h2>
        </div>
        <div class="header-info">
          <div class="info-detail">
            <span>客户名称：{{ tableInfo.customerName }}</span
            ><span>单据编号：{{ tableInfo.documentNumber }}</span>
          </div>
          <div>送货地址：{{ tableInfo.deliveryAddress }}</div>
          <div class="info-detail">
            <span>联系人：{{ tableInfo.contactName }}</span>
            <span>联系电话：{{ tableInfo.contactPhone }}</span>
          </div>
        </div>
      </div>
      <div class="header-right">
        <div>
          <qrcode-vue
            :size="size"
            :value="qrcodeVal"
            class="sn-bs-qr-code"
          ></qrcode-vue>
        </div>
        <div>发货日期:{{ tableInfo.sellDate }}</div>
      </div>
    </div>
    <div class="table-box">
      <el-table
        v-loading="loading"
        :cell-style="{ height: '30px', padding: '5px 0' }"
        :data="tableData"
        :header-cell-style="{ background: '#eee' }"
        border
        class="table-class"
        empty-text=" "
        stripe
      >
        <el-table-column label="序号" prop="serialNumber" width="50px">
          <!-- <template slot-scope="scope"> </template> -->
        </el-table-column>
        <el-table-column label="商品编码" prop="goodsCode"></el-table-column>
        <el-table-column label="商品名称" prop="goodsName"></el-table-column>
        <el-table-column label="规格" prop="specification" width="80px">
        </el-table-column>
        <el-table-column label="品牌" prop="brandName" width="80px">
        </el-table-column>
        <el-table-column label="单位" prop="unit" width="50px">
        </el-table-column>
        <el-table-column label="数量" prop="amount" width="80px">
        </el-table-column>
        <el-table-column label="单价" prop="sellPrice" width="80px">
        </el-table-column>
        <el-table-column label="金额" prop="money" width="80px">
        </el-table-column>
        <el-table-column label="生产日期" prop="productDate"></el-table-column>
        <div slot="append">
          <div class="customRow">
            <div class="">单页合计</div>
            <div class="">{{ spaNumTotal }}</div>
            <div class=""></div>
            <div class="">{{ spaJeTotal }}</div>
            <div class=""></div>
          </div>
          <div class="customRow">
            <div class="">总计</div>
            <div class="">{{ numTotal }}</div>
            <div class=""></div>
            <div class="">{{ amountTotal }}</div>
            <div class=""></div>
          </div>
        </div>
      </el-table>

      <div class="signature info-detail">
        <span>制单人: {{ companyUserName }}</span
        ><span>审核人: ____________ </span><span>发货人签字: ____________ </span
        ><span>收货人签字: ____________ </span>
      </div>
      <div class="signature info-detail">
        <span>送货单位(盖章):{{ companyName }}</span
        ><span>送货人签字: ____________ </span
        ><span
          >送货车辆(车牌号): {{ tableInfo.carNumber || "____________" }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import { maxDecimalPlaces, getPageParams } from "@/utils";
import { getStorage } from "@/utils/storage";

export default {
  name: "Preview",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      loading: false,
      spaNumTotal: 0,
      spaJeTotal: 0,
      qrcodeVal: "",
      size: "120",
      companyName: getStorage("COMPANYINFO").companyName,
      companyUserName: getStorage("COMPANYINFO").companyUserName,
      uuid: "",
    };
  },
  props: {
    tableData: {
      type: Array,
      default: () => {
        [];
      },
    },
    pageNo: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    numTotal: {
      type: Number,
      default: 0,
    },
    amountTotal: {
      type: Number,
      default: 0,
    },
    tableInfo: {
      type: Object,
      default: () => {},
    },
  },
  created() {
    this.init();
  },
  watch: {
    tableInfo() {
      this.init();
    },
    tableData() {
      this.figureUp();
    },
  },

  methods: {
    async init() {
      //   this.salesInfo = await SessionStorage.get("phd");
      //   console.log("this...", this.salesInfo);
      let companyInfo = getStorage("COMPANYINFO");
      let farmInfo = getStorage("FARMINFO");

      this.uuid = getPageParams().uuid;
      if (this.tableInfo.uuid || this.uuid) {
        this.qrcodeVal = encodeURI(
          `${process.env.VUE_APP_HGZ}/#/home/jyhgz/${
            this.uuid ? this.uuid : this.tableInfo.uuid
          }?countyId=${farmInfo.countyId}&enterpriseCreditCode=${
            companyInfo.enterpriseCreditCode
          }&supervisionFlag=${companyInfo.supervisionFlag}`
        );
        this.figureUp();
      }
    },
    //计算单页总价
    figureUp() {
      this.spaNumTotal = maxDecimalPlaces(
        this.tableData.reduce((prev, cur) => {
          return prev + Number(cur.amount || 0);
        }, 0)
      );
      this.spaJeTotal = maxDecimalPlaces(
        this.tableData.reduce((prev, cur) => {
          return prev + Number(cur.money || 0);
        }, 0)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.distribution {
  width: 900px;
  margin: 0 auto;
  padding: 50px 0;
  height: 600px;
  overflow: hidden;

  .header {
    display: flex;
    justify-content: space-between;

    &-title {
      position: relative;

      .page-num {
        position: absolute;
        right: 1px;
        top: 1px;
      }

      h2 {
        font-size: 40px;
        text-align: center;
        margin-bottom: 30px;
      }
    }

    &-left {
      flex: 1;
      margin-right: 40px;
    }

    &-right {
      width: 175px;
      font-size: 16px;
      //   img {
      //     width: 120px;
      //     height: 120px;
      //     margin: 0 auto 10px;
      //     display: block;
      //   }
      .sn-bs-qr-code {
        width: 120px;
        height: 120px;
        margin: 0 auto 10px;
        display: block;
      }
    }

    &-info {
      width: 600px;
      font-size: 18px;
      line-height: 28px;
    }
  }

  .info-detail {
    display: flex;
    justify-content: space-between;
  }

  .table-box {
    margin: 10px 0;

    .table-class {
      margin-bottom: 10px;
    }

    .signature {
      line-height: 34px;
    }
  }

  .customRow {
    display: flex;
    width: 900px;
    height: 34px;
    line-height: 34px;
    border-bottom: 1px solid #ebeef5;
    overflow: hidden;
    font-weight: bold;

    div {
      width: 83px;
      padding: 0 10px;
      border-right: 1px solid #ebeef5;
      box-sizing: border-box;
    }

    div:first-child {
      width: 550px;
      text-align: right;
      padding-right: 33px;
    }

    div:nth-child(5) {
      width: 139px;
    }

    div:last-child {
      border-right: none;
    }
  }
}
</style>
